import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Esito } from 'src/app/common/models/esito';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../../models/liquidato';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaLiquidatiUpdateComponent } from './sezione-economica-liquidati-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-liquidati-update]',
  templateUrl: 'sezione-economica-mod-liquidati-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaLiquidatiModUpdateComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formLiquidatiUpdate') formLiquidati: SezioneEconomicaLiquidatiUpdateComponent;

  inizializza(sezione: SezioneEconomica, liquidato: Liquidato, fascicolo: FascicoloFull, urlUpdate: string, isViewTerzoPignorato: boolean, idSezioneEsiti: string, urlReadSezioneEsiti: string, esito: Esito) {
      this.formLiquidati.inizializza(sezione, liquidato, fascicolo, urlUpdate, isViewTerzoPignorato, idSezioneEsiti, urlReadSezioneEsiti, esito);
    openModal('modaleLiquidatiUpdate');
  }

  createForm() {
      this.formLiquidati.createForm();
  }

  manageModal() {
      closeModal('modaleLiquidatiUpdate');
      this.onReturn.emit();
  }
}
